import {inject, Injectable} from '@angular/core';
import {Observable, shareReplay} from 'rxjs';
import {distinctUntilChanged, map, switchMap} from 'rxjs/operators';
import {DynamicZyxDaemonService} from '../../../components/dynamic-xyz/dynamic-zyx-daemon.service';

@Injectable()
export class DexFilterOTxByUserWalletsService {

    private readonly dynamicZyxDaemonService = inject(DynamicZyxDaemonService);

    private readonly sharedUserWalletAddressesStream$ = this.createSharedUserWalletAddressesStream();

    public getUserWalletAddressesStream(): Observable<string[] | undefined> {
        return this.sharedUserWalletAddressesStream$;
    }

    private createSharedUserWalletAddressesStream(): Observable<string[] | undefined> {
        const areArraysEqual = (a: string[], b: string[]): boolean => {
            if (a === b) return true;
            if (a.length !== b.length) return false;
            for (let i = 0; i < a.length; i++) {
                if (a[i] !== b[i]) return false;
            }
            return true;
        };

        return this.dynamicZyxDaemonService.getIsLoggedInStream().pipe(
            switchMap(isAuth => isAuth
                ? this.dynamicZyxDaemonService.dynRemote.userWallets$.pipe(
                    map(ws => ws.map(w => w.address).sort()),
                    distinctUntilChanged(areArraysEqual)
                )
                : undefined
            ),
            shareReplay({bufferSize: 1, refCount: true})
        );
    }

}
